export default __webpack_public_path__ + "static/media/6_four.79d72043.png";